// extracted by mini-css-extract-plugin
export var sectionsTable = "sections-table_EHPCMMGGG6C7c7l6YCMQ";
export var sectionsTableBody = "sections-table__body_u_8bfJvMrm1Q8Vc7Lvow";
export var sectionsTableHead = "sections-table__head_vquHwgFvqD0C8u6uy3fe";
export var sortableList = "sortable__list_sZjfA4SPz9w0aFTthPO5";
export var sortableListMoving = "sortable__list_moving_MqibxWD4SKrcK9I68lT9";